import { HierarchyAccessError } from "./api";

export async function boundedBytes(response: Response, max: number, signal?: AbortSignal): Promise<Uint8Array<ArrayBuffer>> {
  if (!response.ok || !response.body) throw new HierarchyAccessError();
  const declared = response.headers.get("content-length");
  if (declared && Number(declared) > max) { await response.body.cancel(); throw new HierarchyAccessError(); }
  const reader = response.body.getReader();
  const chunks: Uint8Array[] = [];
  let size = 0;
  try {
    for (;;) {
      signal?.throwIfAborted();
      const next = await reader.read();
      if (next.done) break;
      size += next.value.byteLength;
      if (size > max) throw new HierarchyAccessError();
      chunks.push(next.value);
    }
  } finally { await reader.cancel(); reader.releaseLock(); }
  signal?.throwIfAborted();
  const bytes = new Uint8Array(size);
  let offset = 0;
  for (const chunk of chunks) { bytes.set(chunk, offset); offset += chunk.byteLength; }
  return bytes;
}
